<template>
<div>
  <van-dialog
      v-model="showedialog"
      title = "选择要取消的订单"
      :show-cancel-button="true"
      :show-confirm-button="false"
   >
  <van-cell v-for="item in list" :key="item.id" :title="item.orderNumbers" @click="$emit('rejectExtraReview', item)" />
  </van-dialog>
</div>
</template>

<script>
export default {
  name: "RejectExtraReviewDialog",
  props:{
    showedialog: Boolean,
    list: Array
  }
}
</script>

<style scoped>

</style>
